import moment from 'moment';
import { date } from '../utils';

export const ADD_CORRELATION = 'ADD_CORRELATION';
export const addCorrelation = (id) => ({
    type: ADD_CORRELATION,
    payload: {
        id,
        creationDateTime: moment(date()).toISOString(),
    },
});

export const CLEAN_CORRELATIONS = 'CLEAN_CORRELATIONS';
export const cleanCorrelations = () => ({
    type: CLEAN_CORRELATIONS,
    payload: moment(date()).toISOString(),
});

export const REMOVE_CORRELATION = 'REMOVE_CORRELATION';
export const removeCorrelation = (id) => ({
    type: REMOVE_CORRELATION,
    payload: id,
});
